module.exports = __webpack_public_path__ + "aa4e7c2591f9fa00aa25e34256cc1c1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_6.jpg
// module id = 1683
// module chunks = 5